import { Injectable } from '@angular/core';

import { BaseReferenceService } from './base';

@Injectable({
  providedIn: 'root',
})
export class ModeOfTransportReferenceService extends BaseReferenceService {
  constructor() {
    super('ModeOfTransportReference');
  }
}
